<div class="settings-panel" (click)="$event.stopPropagation()">
  <div class="header">
    <h4 class="header-title">{{ 'module.energyMap.settingsPanel.headerText' | translate }}</h4>
  </div>

  <div class="content">
    <h5 class="title">{{ 'module.energyMap.settingsPanel.subHeaderText' | translate }}</h5>
    <app-error-banner *ngIf="error" warning="{{ 'module.energyMap.settingsPanel.validationSpecifiedRangeText' | translate }}"></app-error-banner>
    <div class="controls">
      <div [ngSwitch]="isUpdating">
        <div *ngSwitchCase="true">
          <div class="price-container">
            {{ 'module.energyMap.settingsPanel.isUpdatingText' | translate }}
          </div>
        </div>
        <div *ngSwitchDefault>
          <div class="price-container">
            <input
              title="price-input"
              #priceInput
              class="price-input"
              maxlength="4"
              type="text"
              value="{{ price.value }}"
              (input)="inputPriceChange.next($event.target.value)"
              [disabled]="!!!authService.permissions.MUNICIPALITY_ELECTRICITY_COST_UPDATE"
            />
            <span class="label">{{ 'module.energyMap.settingsPanel.unitText' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="control-group">
        <span class="fa fa-floppy-o fa-lg control" (click)="updatePrice()" *ngIf="!!authService.permissions.MUNICIPALITY_ELECTRICITY_COST_UPDATE"></span>
      </div>
    </div>
  </div>
</div>
